import { createContext, useState } from "react"
import API from "services/api"
import _ from "lodash"

export const TemplateContext = createContext({})

const TemplateProvider = (props) => {
	const [reportTemplates, setReportTemplates] = useState([])
	const [detailTemplate, setDetailTempalte] = useState(null)

	const getTemplate = async (params) => {
		await API.getTemplate(params)
			.then((res) => {
				const { data } = res

				setReportTemplates(data)
			})
			.catch((err) => {
				throw err
			})
	}

	const postTemplate = (sendData) => {
		return API.postTemplate(sendData)
			.then((res) => {
				const { data } = res

				return data
			})
			.catch((err) => {
				throw err
			})
	}

	const getDetailTemplate = (sendData) => {
		return API.getDetailTemplate(sendData)
			.then((res) => {
				const { data } = res

				setDetailTempalte(data)
				return data
			})
			.catch((err) => {
				throw err
			})
	}

	const putTemplate = (id, sendData) => {
		return API.putTemplate(id, sendData)
			.then((res) => {
				const { data } = res

				return data
			})
			.catch((err) => {
				throw err
			})
	}

	const deleteTemplate = (id) => {
		return API.deleteTemplate(id)
			.then((res) => {
				const { data } = res

				return data
			})
			.catch((err) => {
				throw err
			})
	}

	return (
		<TemplateContext.Provider
			value={{
				reportTemplates,
				detailTemplate,
				setDetailTempalte,

				getTemplate,
				postTemplate,
				putTemplate,
				deleteTemplate,
				getDetailTemplate
			}}
			{...props}
		/>
	)
}

export default TemplateProvider
